/* Express Checkout - SINGLE BUTTON ONLY - MediterraneanArt.ch */
(function() {
  let buttonAdded = false;

  // The engraving product uses its actual product form, including external fields.
  function addEngravingExpressButton(productForm) {
    if (productForm.querySelector('.ma-gravur-express')) return;
    const buttons = productForm.querySelector('.product-form__buttons');
    const addButton = productForm.querySelector('button[name="add"]');
    if (!buttons || !addButton) return;
    const expressButton = document.createElement('button');
    expressButton.type = 'button';
    expressButton.className = 'mediterranean-express-checkout ma-gravur-express';
    expressButton.textContent = '⚡ Jetzt kaufen';
    const error = document.createElement('p');
    error.className = 'ma-engraving-express-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    buttons.prepend(error);
    buttons.prepend(expressButton);
    let loading = false;
    const syncAvailability = () => {
      expressButton.disabled = loading || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
    };
    const observer = new MutationObserver(syncAvailability);
    observer.observe(addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    syncAvailability();
    expressButton.addEventListener('click', async (event) => {
      event.preventDefault();
      if (loading || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') return;
      error.hidden = true;
      const engraving = productForm.elements.namedItem('properties[Gravurtext]')?.closest('ma-engraving-field');
      if (typeof engraving?.validate !== 'function') {
        error.textContent = 'Das Gravurfeld wird geladen. Bitte lade die Produktseite erneut, falls es nicht erscheint.';
        error.hidden = false;
        return;
      }
      if (!engraving.validate() || !productForm.reportValidity()) return;
      loading = true;
      syncAvailability();
      expressButton.textContent = 'Wird geladen…';
      expressButton.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(productForm)
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : 'Das Produkt konnte nicht hinzugefügt werden. Bitte prüfe die Menge.');
        }
        window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch (failure) {
        error.textContent = failure.message || 'Es gab einen Fehler. Bitte versuche es erneut.';
        error.hidden = false;
      } finally {
        loading = false;
        expressButton.textContent = '⚡ Jetzt kaufen';
        expressButton.removeAttribute('aria-busy');
        syncAvailability();
      }
    });
  }

  function addEngravingButtons() {
    document.querySelectorAll('form[data-ma-gravur="true"]').forEach(addEngravingExpressButton);
  }
  document.addEventListener('shopify:section:load', addEngravingButtons);
  document.addEventListener('product-info:loaded', addEngravingButtons);

  
  function addSingleExpressButton() {
    // Prevent multiple executions
    if (buttonAdded) return;

    const engravingForm = document.querySelector('form[data-ma-gravur="true"]');
    if (engravingForm) {
      addEngravingButtons();
      buttonAdded = true;
      return;
    }
    // Featured-product and collection entry points lead to the full engraving page.
    const firstProductForm = document.querySelector('form[action*="/cart/add"]');
    if (firstProductForm?.closest('product-info')?.querySelector('[data-ma-engraving-link]')) return;

    
    // Remove ALL existing Mediterranean buttons first
    document.querySelectorAll('.mediterranean-express-checkout').forEach(btn => btn.remove());
    
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    
    // Create the Express Checkout Button
    const expressButton = document.createElement('button');
    expressButton.type = 'button';
    expressButton.className = 'mediterranean-express-checkout';
    expressButton.innerHTML = '<span class="lightning">⚡</span> Jetzt kaufen';
    
    // Express Checkout Click Handler
    expressButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantId = productForm.querySelector('[name="id"]');
      const quantity = productForm.querySelector('[name="quantity"]') || {value: 1};
      
      if (!variantId || !variantId.value) {
        alert('Bitte wählen Sie eine Produktvariante.');
        return;
      }
      
      // Show loading
      expressButton.innerHTML = '<span class="lightning">⚡</span> Wird geladen...';
      expressButton.disabled = true;
      
      // Add to cart and checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId.value,
          quantity: parseInt(quantity.value) || 1
        })
      })
      .then(response => response.json())
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Express checkout error:', error);
        alert('Es gab einen Fehler. Bitte versuchen Sie es erneut.');
        expressButton.innerHTML = '<span class="lightning">⚡</span> Jetzt kaufen';
        expressButton.disabled = false;
      });
    });
    
    // Smart positioning: Find the right place to insert SINGLE button
    const quantityElement = productForm.querySelector('.quantity-selector, [name="quantity"]');
    
    if (quantityElement && quantityElement.parentElement) {
      // Insert right before the quantity selector
      quantityElement.parentElement.insertBefore(expressButton, quantityElement);
      buttonAdded = true;
      console.log('Express button added before quantity selector');
    } else {
      // Fallback: add at top of form
      productForm.insertBefore(expressButton, productForm.firstElementChild);
      buttonAdded = true;
      console.log('Express button added at form start');
    }
  }
  
  // Run once when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSingleExpressButton);
  } else {
    addSingleExpressButton();
  }
  
})();

